import Vue from 'vue';
import Vuex from 'vuex';
import { IAppState } from './modules/app';
import { IUserState } from './modules/user';
import { IWorkbenchLayout } from './modules/workBench';
import { IWorkbenchLayoutS } from './modules/workBenchServicer';

Vue.use(Vuex);

export interface IRootState {
  app: IAppState
  user: IUserState
  workbenchlayout: IWorkbenchLayout
  workbenchLayoutS: IWorkbenchLayoutS
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({});
